import { render, staticRenderFns } from "./CompoundsClosed.vue?vue&type=template&id=4465cf80&"
import script from "./CompoundsClosed.vue?vue&type=script&lang=js&"
export * from "./CompoundsClosed.vue?vue&type=script&lang=js&"
import style0 from "./CompoundsClosed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports